import Router from 'next/router';
import getConfig from 'next/config';

import { createEventTracker } from '@zapier/toolbox-tracking';

const {
  publicRuntimeConfig: { COMMIT_HASH },
} = getConfig() || { publicRuntimeConfig: {} };

const attachSSRMetadata = () => async event => {
  event.apply({
    siteVersion: COMMIT_HASH,
    path: Router.asPath,
    pageRoute: Router.route,
  });

  event._deprecatedSetProprtiesInRoot(['siteVersion', 'path', 'pageRoute']);
};

const trackingFunctions = createEventTracker([attachSSRMetadata]);

export const { trackEvent } = trackingFunctions;

export default trackingFunctions;
